(function() {
  const STORAGE_KEY = 'recentlyViewedProducts'; 

  const trackProduct = () => {
    if (!window.location.pathname.match(/\/products\//i)) return;

    const rawPath = window.location.pathname;
    const currentHandle = rawPath.split('/products/')[1].split('?')[0].split('/')[0];
    const currentFullUrl = rawPath + window.location.search;

    let history = [];
    try {
      history = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      if (!Array.isArray(history)) history = [];
    } catch(e) {
      console.warn('History Tracker: corrupted storage, resetting.', e);
      history = [];
    }

    const purgedHistory = history.filter(entryUrl => {
      if (typeof entryUrl !== 'string') return false;
      
      try {
        const pathPart = entryUrl.split('/products/')[1];
        if (!pathPart) return false; 
        const storedHandle = pathPart.split('?')[0].split('/')[0];
        return storedHandle !== currentHandle; 
      } catch (err) { 
        return false; 
      }
    });

    const newHistory = [currentFullUrl, ...purgedHistory].slice(0, 21);

    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(newHistory));
    //   localStorage.setItem(STORAGE_KEY, {});
      window.dispatchEvent(new CustomEvent('history-updated')); 
    } catch(e) {
      console.error('History Tracker: LocalStorage full or disabled', e);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', trackProduct);
  } else {
    trackProduct();
  }
})();